export default function noderef(component, refName, propName = "nodeRefs") {
    if (!(propName in component)) {
        component[propName] = {};
    }

    if (!("refHandlers" in component)) {
        component.refHandlers = {};
    }

    const { [propName]: refs, refHandlers } = component;

    if (typeof refHandlers[refName] !== "function") {
        refHandlers[refName] = el => {
            refs[refName] = el;
        };
    }

    return refHandlers[refName];
}
